export default [
  {
    title: 'Inicio',
    icon: 'HomeIcon',
    route: 'dashboard-inicio',
    action: 'read',
    resource: 'Analitycs',
  },
]
